import {Component, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TapToTopComponent } from './shared/components/tap-to-top/tap-to-top.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import {AuthService} from "./core/services/auth.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,TapToTopComponent,LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    // Verificar si hay un token almacenado en localStorage
    let token = localStorage.getItem('authToken');

    // Si el token está presente, restauramos la sesión
    if (token) {
      let session = JSON.parse(token);
      this.authService.setPermissions(session.p);
      this.authService.setUser(session.u);
    }
  }

}
